import { useParams } from 'react-router-dom'

import { BeketDifficultRoute } from 'entities/beket/models/find-ticket/model'
import { DifficultRoute } from 'entities/ticket/models/find-ticket/models'

interface SearchDynamicParams {
  [key: string]: string | undefined
}

export const useGetSearchParams = () => {
  const dynamicParams = useParams<SearchDynamicParams>()

  if (!dynamicParams?.params) return null

  const [fromCode, toCode, fromCity, toCity, date] =
    dynamicParams?.params?.split('_')

  if (!fromCode && !toCode && !fromCity && toCity && !date) return null

  const direction: DifficultRoute = {
    from: {
      countryName: '',
      cityIataCode: fromCode,
      cityName: decodeURIComponent(fromCity),
    },
    to: {
      countryName: '',
      cityIataCode: toCode,
      cityName: decodeURIComponent(toCity),
    },
    date: date,
  }

  return direction
}

export const useGetSearchParamsBeket = () => {
  const dynamicParams = useParams<SearchDynamicParams>()

  if (!dynamicParams?.params) return null

  const [fromCode, toCode, fromCity, toCity, date] =
    dynamicParams?.params?.split('_')

  if (!fromCode && !toCode && !fromCity && toCity && !date) return null

  const direction: BeketDifficultRoute = {
    to: {
      countryName: '',
      id: parseInt(toCode),
      cityName: decodeURIComponent(toCity),
    },
    from: {
      countryName: '',
      id: parseInt(fromCode),
      cityName: decodeURIComponent(fromCity),
    },
    date: date,
  }

  return direction
}
